import { AppBar, Toolbar, Typography, Box } from "@mui/material";
import TPLDesignMark from "../../resources/tpl_design_mark_earth.svg";
import TPLSearchBar from "./TPLSearchBar";
import DownloadPdfBtn from "./DownloadPdfBtn";
import MenuLinksDropDown from "./MenuLinksDropDown";

const Navbar = () => {
  return (
    <>
      <AppBar
        sx={{ backgroundColor: "snow.main" }}
        elevation={0}
        position="static"
        className="navbar__container"
      >
        <Toolbar className="navbar__toolbar">
          <Box className="navbar__brand-container">
            <Box className="navbar__brand-logo" sx={{ width: { xs: "36px", lg: "48px" }, mx: 3, my: 1 }}>
              <img
                className="navbar__brand-img"
                src={TPLDesignMark}
              />
            </Box>
            <Typography
              variant="h1"
              noWrap
              sx={{ color: "earth.main", fontWeight: 750 }}
              className="navbar__brand-header"
            >
              ParkServe
            </Typography>
            <Typography
              variant="h4"
              noWrap
              sx={{ color: "earth.main", lineHeight: 1, marginBottom: "1rem" }}
              className="navbar__brand-header"
            >
              ®
            </Typography>
          </Box>
          <Box flex={1} className="navbar__search-bar" justifyContent="center">
            <TPLSearchBar />
          </Box>
          <Box className="navbar__button-group">
          <MenuLinksDropDown />
          <DownloadPdfBtn />  
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Navbar;
